import { animate } from "motion";

export class HeroCrossfade {
	constructor() {
		this.hero = document.querySelector(".home-hero");
		if (!this.hero) return;

		this.images = this.hero.querySelectorAll(".home-hero__image");
		this.secondImageWrap = this.hero.querySelector(".home-hero__image-wrap--second");
		if (!this.secondImageWrap) return;

		this.init();
	}

	init() {
		Promise.all(
			[...this.images].map((img) =>
				img.complete ? Promise.resolve() : new Promise((r) => (img.onload = r))
			)
		).then(() => {
			animate(this.secondImageWrap, { opacity: 1 }, { duration: 1.5, delay: 1.5, easing: "ease-out" });
		});
	}
}
